export default {
  title: "Készlet",
  titleDetails: "Készlet részletező",
  stateUpdateModalTitle: "Állapot frissítés",
  addModalTitle: "Készlet hozzáadása",
  revisionModalTitle: "Készlet revizió",
  revisionStornoModalTitle: "Készlet sztornózása",
  revisionReturnModalTitle: "Elhasznált visszavét",
  revisionDescription: "Az itt megadott tömeges módosítások FIFO elv alapján kerülnek végrehajtásra a készleten. A bal oldalon (per jel előtti számok) jelölik a teljes elérhető mennyiséget, azt követően pedig a művelet során érintett elemek számát. Nulla esetén az adott soron nem kerül végrehajtásra a művelet. A listán csak olyan elemek szerepelnek, amiknek egyik oszlopában legalább egy módosításra alkalmas elelm található.",
  errorMissingReturnableItem: "Nincs visszavehető elem.",

  status: {
    available: "Elérhető",
    possibly_used: "Felhasznált",
    returned: "Visszavéve",
  },

  columns: {
    status: "Állapot",
    createdAt: "Kiadva",
    usedAt: "Felhasználás ideje",
    returnedAt: "Visszavétel ideje",
    drug: "Gyógyszer",
    countAvailable: "Elérhető",
    expiredAt: "Lejárati ideje",
    countPossiblyUsed: "Felhasznált",
    countReturned: "Visszavett",
    amount: "Mennyiség",
    lotId: "Lot ID"
  },

  actions: {
    returnUsed: "Használt visszavétel",
    returnAvailable: "Elérhető visszavétel",
    return: "Visszavétel",
    storno: "Sztornózás"
  }
}
